module.exports = __webpack_public_path__ + "img/localizacao2.80773b03.png";